.wrp-custom-element {
    width: 220px;
    margin-top: 10px;

    &>label {
        display: inline-block;
        margin-bottom: 5px;
    }
}